module.exports = "/static/js/2631e3e2811a14d9c7c4b442bc136de3.png";